<script>

  import { mapState } from 'vuex'
  import CardArticle from '@/components/CardArticle'
  import CallToAction from '@/components/CallToAction'

  export default {
    components: {
      CardArticle,
      CallToAction
    },
    computed: {
      ...mapState({
        config: state => state.config,
        articles: state => state.blog.articles
      }),
      articlesCTA () {
        if (!this.config.fields || !this.config.fields.articlesArchiveCTA) return false
        return this.config.fields.articlesArchiveCTA.fields
      }
    }
  }
</script>

<template>
  <div class="articles-list container px-4 md:px-8">
    <div class="flex flex-wrap -mx-4">
      <div
        v-for="article in articles.items"
        :key="article.sys.id"
        class="w-full md:w-1/2 lg:w-1/4 px-4 pb-8"
      >
        <card-article :post="article" />
      </div>
      <div
        v-if="articlesCTA"
        class="w-full md:w-1/2 lg:w-1/4 px-4 pb-8"
      >
        <call-to-action :fields="articlesCTA" />
      </div>
    </div>
  </div>
</template>
